export const endAt = ({ theme: { dimensions } }) => ({
    maxWidth: dimensions.inputMediumMaxWidth,
});
